import { Icon } from "antd";
import React, { useEffect, useState } from "react";

import "./SortableList.css";

export const SortableList = ({ items, onSortEnd }) => {
  const [draggingIndex, setDraggingIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [currentItems, setCurrentItems] = useState(items);

  const handleDragStart = (index) => {
    setDraggingIndex(index);
  };

  useEffect(() => {
    setCurrentItems(items);
  }, [items]);

  const handleDragOver = (index) => {
    if (draggingIndex !== null && draggingIndex !== index) {
      const newItems = [...currentItems];
      const [movedItem] = newItems.splice(draggingIndex, 1);
      newItems.splice(index, 0, movedItem);
      setCurrentItems(newItems);
      setDraggingIndex(index);
    }
    setDragOverIndex(index);
  };

  const handleDrop = () => {
    if (draggingIndex !== null && dragOverIndex !== null) {
      onSortEnd(currentItems);
    }
    setDraggingIndex(null);
    setDragOverIndex(null);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  const handleDragEnd = () => {
    setDraggingIndex(null);
    setDragOverIndex(null);
  };

  return (
    <div>
      {currentItems.map((item, index) => (
        <div
          key={item.id}
          className={`sortable-item ${
            draggingIndex === index ? "dragging" : ""
          } ${dragOverIndex === index ? "drag-over" : ""}`}
          draggable
          onDragStart={() => handleDragStart(index)}
          onDragOver={(e) => {
            e.preventDefault();
            handleDragOver(index);
          }}
          onDrop={handleDrop}
          onDragLeave={handleDragLeave}
          onDragEnd={handleDragEnd}
        >
          <span>{item.name}</span>
          <div className="ml-auto children-space-x-4">
            <Icon type="edit" className="cursor-pointer" />
            <Icon type="delete" className="cursor-pointer" />
            <Icon type="menu" className="cursor-move" />
          </div>
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/SortableList/SortableList.js